<template>
    <div class="store-management-box">
        <van-nav-bar title="门店管理" />
        <van-tabs @click="onClick" color="#fe7b43">
            <van-tab name="0" title="全部"></van-tab>
            <van-tab name="2" title="生效中"></van-tab>
            <van-tab name="1" title="审核中"></van-tab>
            <van-tab name="5" title="不通过"></van-tab>
            <van-tab name="4" title="已失效"></van-tab>
        </van-tabs>
        <ul class="store-container">
            <li class="store-item" v-for="(item, index) in storeList" :key="index" @click="showOption(item)">
                <div class="store-item-name">{{ item.simpleName }}</div>
                <div class="store-item-perfect">
                    <span v-if="item.storeType == 1" class="improved">总店</span>
                    <van-icon name="arrow" color="#eeeeee" />
                </div>
            </li>
        </ul>
        <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" @select="onSelect" close-on-click-action />
        <div class="md-btn-box" v-if="isMerchant">
            <div class="remark">注：本机构已有 {{ total }} 个门店</div>
            <van-button type="default" color="#FF6633" block :to="{ path: '/add-or-edit-md', query: { isAdd: true } }">
                添加门店
            </van-button>
        </div>
    </div>
</template>

<script>
import { getMallbranchstore, deleteMallbranchstore, selectIsStore } from '../api/index';
import { Dialog } from 'vant';
export default {
    data() {
        return {
            show: false,
            isMerchant: 1,
            actions: [],
            storeList: [],
            total: '',
            paramas: {
                phone: '',
                audit: '0'
            }
        };
    },
    mounted() {
        this.paramas.phone = this.$globalData.phone1;
        this.selectIsStore();
        this.getMallbranchstore();
    },
    methods: {
        selectIsStore() {
            selectIsStore({ phone: this.paramas.phone }).then((res) => {
                this.isMerchant = res.data.isMerchant;
                if (this.isMerchant) {
                    this.actions.push({ name: '编辑' }, { name: '删除' });
                } else this.actions.push({ name: '编辑' });
            });
        },
        // 打开选项卡
        showOption(e) {
            this.detail = e;
            this.show = true;
        },
        // 点击选项
        onSelect(item) {
            this.show = false;
            if (item.name === '编辑')
                this.$router.push({ path: '/add-or-edit-md', query: { isAdd: false, item: JSON.stringify(this.detail) } });
            if (item.name === '删除') {
                Dialog.confirm({
                    title: '标题',
                    message: '删除该门店无法撤回，确认删除吗？若该门店存在管理员，将同步删除'
                })
                    .then(() => {
                        console.log(this.detail);
                        this.deleteMallbranchstore();
                        // on confirm
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
        },
        // 获取门店
        getMallbranchstore() {
            getMallbranchstore(this.paramas).then((res) => {
                this.storeList = res.data.rows;
                this.total = res.data.total;
            });
        },
        // 删除
        deleteMallbranchstore() {
            const paramas = {
                id: this.detail.mallBranchStoreID,
                phone: this.$globalData.phone1
            };
            deleteMallbranchstore(paramas).then((res) => {
                console.log(res);
                this.getMallbranchstore()
            });
        },
        onClick(e) {
            this.paramas.audit = e;
            this.getMallbranchstore();
        }
    }
};
</script>

<style scoped lang="scss">
.store-management-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .store-container {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        .store-item {
            height: 55px;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 16px;
            border-bottom: 1px solid #eeeeee;

            .store-item-name {
                font-size: 16px;
            }

            .store-item-perfect {
                font-size: 14px;

                .improved {
                    // color: #ff6633;
                }
            }
        }

        .store-item:active {
            background-color: #eeeeee;
        }
    }

    .md-btn-box {
        padding: 10px 10px;
        background-color: #ffffff;
        border-top: 1px solid #eeeeee;

        .remark {
            text-align: center;
            margin-bottom: 10px;
            color: #cbcbcb;
        }

        .van-button {
            font-size: 16px;
        }
    }
}
</style>
